export default __webpack_public_path__ + "static/media/single.c9ef4c05.svg";